import {FC, ReactNode} from "react";
import {FooterActionsType} from "@interstate/components/FooterActions";
import {Slideout} from "@interstate/components/SlideOut";

export interface RightSlideoutProps {
  show: boolean;
  onHide: (...args: any[]) => any;
  id: string;
  header?: ReactNode;
  footer?: FooterActionsType;
  children: NonNullable<ReactNode>;
  className?: string;
  width?: string;
}

export const RightSideSlideout: FC<RightSlideoutProps> = ({
  id,
  show,
  onHide,
  header,
  footer,
  children,
  className,
  width = "600px"
}) => {
  return (
    <Slideout
      id={id}
      data-testid={`${id}-data-testid`}
      position={"right"}
      show={show}
      onHide={onHide}
      header={header}
      footer={footer}
      panelWidth={width}
      className={className}
      sx={{zIndex: 100000}}>
      {children}
    </Slideout>
  );
};
